import React, { Component } from 'react'
import Header from '../Components/header/index.jsx'
import Footer from '../Components/Footer/index'
import './index.scss'
export default class index extends Component {
  state = {
    items: [],
    imgarr: [require('../image/company/北京地勘院.jpg'), require('../image/company/国家电网.jpg'), require('../image/company/徐福记.jpg'), require('../image/company/中国海油.jpg'), require('../image/company/中国航天.jpg'), require('../image/company/中国科学院.jpg'), require('../image/company/中国石化.jpg'), require('../image/company/中国石油.jpg')],

    arr: [],
    num: 0,
    page: 1
  }
  componentWillMount() {
    this.setitem()
    document.title = '高温温湿度_温湿度_智慧物联网_大数据平台_数字孪生_北京锐控自动化科技有限公司|商务合作'
  }
  setitem = () => {
    const { imgarr } = this.state
    const mypage = Math.ceil(imgarr.length / 16)
    let items = []
    let pushitem = []
    let num = 0
    imgarr.forEach((item, index) => {
      num++
      pushitem.push(item)
      if (num == 16) {
        items.push(pushitem)
        pushitem = []
        num = 0
      } else if (imgarr.length == index + 1) {
        items.push(pushitem)
        pushitem = []
        num = 0
      }
    })

    this.setState({ items, page: mypage })
  }
  render() {
    const { items, num } = this.state
    return (
      <div style={{ backgroundColor: '#f0f2f5' }}>
        <Header></Header>
        <div className="cooperationContent">
          <div className="cooperationContent-title">
            <div className="cooperationContent-title-h1">商务合作</div>
            <div className="cooperationContent-title-text">COOPERATION</div>
          </div>
          <div className="cooperationContent-box">
            <div className="cooperationContent-text">北京锐控已为中海油、中石化、中石油，国家电网，徐福记、雪花啤酒、通用电气、北京地勘院、国防某所等众多大型客户提供了长期高品质服务。</div>
          </div>
        </div>
        <div className="cooperation-content">
          <div className="cooperation-content-imageUl">
            {items[num].map((item, i) => (
              <div key={i} className="cooperation-content-imageUl-item" style={{ marginRight: `${(i + 1) % 4 == 0 ? '0' : '0.8rem'}` }}>
                <img src={item} alt="" className="cooperation-content-imageUl-item-img" />
              </div>
            ))}
          </div>
          <div className="cooperation-content-pages">
            <div className="cooperation-content-pages-button" style={{ marginRight: '0.4rem' }} onClick={() => (num != 0 ? this.setState({ num: num - 1 }) : '')}>
              上一页
            </div>
            {items.map((i, index) => (
              <div key={index} className={`cooperation-content-pages-button-text ${index == num ? 'btnbgc' : ''}`} onClick={() => this.setState({ num: index })}>
                {index + 1}
              </div>
            ))}
            <div className="cooperation-content-pages-button" onClick={() => (num + 1 < items.length ? this.setState({ num: num + 1 }) : '')}>
              下一页
            </div>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}
